var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"flex justify-between items-center"},[_c('h2',{staticClass:"m-0",domProps:{"textContent":_vm._s('Account Verification')}}),_vm._v(" "),_c('AccountStatusBanner',{staticClass:"ml-4",attrs:{"setup-mode":_vm.setupMode}})],1),_vm._v(" "),_c('RequirementsContainer',{attrs:{"setup-mode":_vm.setupMode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }